// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'
// import VueScrollReveal from 'scrollreveal';

Vue.use(VueViewer)
Vue.config.productionTip = false
Vue.prototype.$baseUrl =process.env.NODE_ENV=='production'?"http://www.4dmodel.com/SuperTwoCustom/XXBWG": "http://localhost:8080";
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js